import Track from '../../../utils/tracking';

const validateContactNumberForOptty = (contactNumber) => {
  try {
    if (!contactNumber) {
      return false;
    }
  } catch (e) {
    Track.error(`Error matching regex to determine if contact number valid for Optty, returning true to not block order placement attempt: ${e}`);
    return true;
  }
};

export default validateContactNumberForOptty;
